import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { CustomToastService } from "./toast.service";
import { AuthService } from "../auth.service";
import { AuditLogService } from "./audit-log.service";
import { environment } from "../../environments/environment";
import { tap } from 'rxjs/operators';
import { getAllCustomFieldResponse } from "../pages/no-code/optional-input/list-per-key/interface/get-all-custom-fields-response";
import * as vo from "../interface/_index";
import { BaseResponse } from "../interface/base-response-i";

@Injectable({
  providedIn: "root",
})
export class AdminService {
  private apiUrl = `${environment.apiUrl}/api`;

  private token = "test";
  constructor(
    private http: HttpClient,
    private router: Router,
    private authService: AuthService,
    private auditLogService: AuditLogService,
    private customToast: CustomToastService,
    public toastr: ToastrService
  ) {}

  // Method to send GET request with Bearer token
  getTransactions(
    token: string,
    size: number,
    isExport: boolean,
    page: number,
    filterOptions: any,
    sortColumn: any,
    sortDirection:any
  ): Observable<any> {
    const filterParams = new URLSearchParams();
   
    if (filterOptions.merchantName) filterParams.append("merchantName", filterOptions.merchantName);
    if (filterOptions.merchantId) filterParams.append("merchantId", filterOptions.merchantId);
    if (filterOptions.transactionNo) filterParams.append("refNo", filterOptions.transactionNo);
    if (filterOptions.status) filterParams.append("status", filterOptions.status);
    if (filterOptions.startDate) filterParams.append("startDate", filterOptions.startDate+' 00:00:00');
    if (filterOptions.endDate) filterParams.append("endDate", filterOptions.endDate+' 00:00:00');
    if (sortColumn == 'merchantIdSort') filterParams.append("merchantIdSort", sortDirection)
    if (sortColumn == 'refNoSort') filterParams.append("refNoSort", sortDirection);
    if (sortColumn == 'statusSort') filterParams.append("statusSort", sortDirection);
    if (sortColumn == 'createdAtSort') filterParams.append("createdAtSort", sortDirection);

    const filterQuery = filterParams.toString() ? `&${filterParams.toString()}` : "";
    const headers = new HttpHeaders({
      Authorization: "Bearer " + token,
    });

    return this.http.get(
      `${this.apiUrl}/v2/transaction-detail/record?size=${size}&page=${page}&isExport=${isExport}${filterQuery}`,
      { headers: headers, responseType: isExport ? ("blob" as "json") : "json" }
    );
  }

  getAccounts(
    token: string,
    size: number,
    page: number,
  ): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    /// values filter to follow
    const filter ='';
    return this.http.get(
      `${this.apiUrl}/v2/admin/account/record?size=${size}&page=${page}${filter}`,
      { headers: headers }
    );
  }

  // Method to send POST request with Bearer token
  createAccount(
    token: string,
    email: string,
    username: string,
    password: string,
    role: string
  ): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    // note typo in B.E yung userName XD
    return this.http.post(
      `${this.apiUrl}/v2/admin/account/create-access`,
      { email, userName: username, password, role },
      { headers: headers }
    ).pipe(
      tap(() => this.auditLogService.log(
        'POST', '/v2/admin/account/create-access', 'Created account for: ' + username, 'Accounts - Create Account',
        this.authService.getToken(), this.authService.getUserId()
      ))
    );
  }
  updatePassword(
    token: string,
    currentPassword: string,
    newPassword: string,
    newPasswordConfirm: string
  ): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.http.patch(
      `${this.apiUrl}/auth/change-password`,
      { currentPassword, newPassword, newPasswordConfirm },
      { headers: headers }
    );
  }

  changeAccountStatus(
    token: string,
    request: vo.AccountChangeStatusRequest
  ): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.http.put(
      `${this.apiUrl}/v2/users/update-status`,
      request,
      { headers: headers }
    ).pipe(
      tap(() => this.auditLogService.log(
        'PUT', 'v2/users/update-status', 'Updated account status for user: ' + request.username, 'Accounts - Update Account Status',
        this.authService.getToken(), this.authService.getUserId()
      ))
    );
  }

  grantMid(
    token: string,
    userId: string,
    merchantName: string
  ): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.http.post(
      `${this.apiUrl}/v2/admin/merchant/grant-id`,
      { userId, merchantName },
      { headers: headers }
    ).pipe(
      tap(() => this.auditLogService.log(
        'POST', '/v2/admin/merchant/grant-id', 'Granted MID for merchant: ' + merchantName, 'Accounts - Grant MID',
        this.authService.getToken(), this.authService.getUserId()
      ))
    );
  }

  getMidList(
    token: string,
    size: number,
    isExport: boolean,
    page: number,
    filterOptions: any,
    sortColumn: any,
    sortDirection:any
  ): Observable<any> {

    const filterParams = new URLSearchParams();
   
    if (filterOptions.merchantName) filterParams.append("merchantName", filterOptions.merchantName);
    if (filterOptions.merchantId) filterParams.append("merchantId", filterOptions.merchantId);
    if (filterOptions.startDate) filterParams.append("startDate", filterOptions.startDate+' 00:00:00');
    if (filterOptions.endDate) filterParams.append("endDate", filterOptions.endDate+' 00:00:00');
    if (sortColumn == 'createdAtSort') filterParams.append("createdAtSort", sortDirection);
    if (sortColumn == 'merchantNameSort') filterParams.append("merchantNameSort", sortDirection);

    const filterQuery = filterParams.toString() ? `&${filterParams.toString()}` : "";
    const headers = new HttpHeaders({
      Authorization: "Bearer " + token,
    });

    return this.http.get(
      `${this.apiUrl}/v2/merchant-info/record?size=${size}&page=${page}&isExport=${isExport}${filterQuery}`,
      { headers: headers, responseType: isExport ? ("blob" as "json") : "json" }
    );

    // return this.http.get(
    //   `${this.apiUrl}/v2/transaction-detail/record?size=${size}&page=${page}&isExport=${isExport}${filterQuery}`,
    //   { headers: headers, responseType: isExport ? ("blob" as "json") : "json" }
    // );
  }

  
  generateApiKey(token: string, merchantId: string): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.http.post(
      `${this.apiUrl}/v2/api-key/create`,
      { merchantId },
      { headers: headers }
    ).pipe(
      tap(() => this.auditLogService.log(
        'POST', '/v2/api-key/create', 'Generated API key for merchant: ' + merchantId, 'MID - Generate API Key',
        this.authService.getToken(), this.authService.getUserId()
      ))
    );
  }

  saveCustomField(
    token: string,
    data: vo.CreateInputRequestI,
    merchantId: string
  ): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.http.post(
      `${this.apiUrl}/v2/no-code/input?merchantId=${merchantId}`,
      data,
      { headers: headers }
    ).pipe(
      tap(() => this.auditLogService.log(
        'POST', '/v2/no-code/input', 'Created custom field', 'Settings - Create Custom Field',
        this.authService.getToken(), this.authService.getUserId()
      ))
    );
  }

  getAllCustomField(
    token: string,
    merchantId: string,
    size?: number,
    page?: number
  ): Observable<getAllCustomFieldResponse> {
    const headers = new HttpHeaders({
      Authorization: "Bearer " + token,
    });

    let params = new HttpParams().set("merchantId", merchantId);
    if (size !== undefined) params = params.set("size", size);
    if (page !== undefined) params = params.set("page", page);

    return this.http.get<getAllCustomFieldResponse>(
      `${this.apiUrl}/v2/no-code/input/record`,
      { headers, params }
    );
  }

  deleteCustomField(
    token: string,
    merchantId: string,
    id: number
  ): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.http.delete(
      `${this.apiUrl}/v2/no-code/input?merchantId=${merchantId}&id=${id}`,
      { headers: headers }
    ).pipe(
      tap(() => this.auditLogService.log(
        'DELETE', '/v2/no-code/input', 'Deleted custom field ID: ' + id, 'Settings - Delete Field',
        this.authService.getToken(), this.authService.getUserId()
      ))
    );
  }

  getMerchantList(
    token: string,
    size: string,
    page: string,
    filter?: vo.MerchantListFilterI
  ): Observable<BaseResponse<vo.MerchantResponseI>> {
    const headers = new HttpHeaders({
      Authorization: "Bearer " + token,
    });

    let params = new HttpParams()
      .set("size", size)
      .set("page", page);

    if (filter) {
      Object.entries(filter).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          params = params.set(key, value.toString());
        }
      });
    }

    return this.http.get<BaseResponse<vo.MerchantResponseI>>(
      `${this.apiUrl}/v2/merchant-info/record`,
      { headers, params }
    );
  }

  getSubMerchants(
    token: string,
    username: string
  ): Observable<BaseResponse<vo.SubMerchant>> {
    const headers = new HttpHeaders({
      Authorization: "Bearer " + token,
    });

    return this.http.post<BaseResponse<vo.SubMerchant>>(
      `${this.apiUrl}/v2/admin/account/merchants-list`,
      { username: username },
      { headers: headers }
    );
  }

  saveWebhook(
    token: string,
    merchantId: string,
    successCallBack: string,
    failedCallBack: string,
    expiredCallBack: string
  ): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.http.post(
      `${this.apiUrl}/v2/webhook/save-call-back`,
      { merchantId, successCallBack, failedCallBack, expiredCallBack },
      { headers: headers }
    ).pipe(
      tap(() => this.auditLogService.log(
        'POST', '/v2/webhook/save-call-back', 'Saved webhook settings', 'Settings - Webhook',
        this.authService.getToken(), this.authService.getUserId()
      ))
    );
  }

  getCallbacks(
    token: string,
    merchantId: string
  ): Observable<BaseResponse<vo.WebhookCallbacksI>> {
    const headers = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.http.get<BaseResponse<vo.WebhookCallbacksI>>(
      `${this.apiUrl}/v2/webhook/api-call-back`,
      { headers, params: new HttpParams().set("merchantId", merchantId) }
    );
  }


  changePassword(
    token: string,
    request: vo.ChangePassRequestI
  ): Observable<BaseResponse<{}>> {
    const headers = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.http.patch<BaseResponse<{}>>(
      `${this.apiUrl}/v2/password/change-password`,
      request,
      { headers: headers }
    ).pipe(
      tap(() => this.auditLogService.log(
        'POST', '/v2/password/change-password', 'Password changed successfully', 'Settings - Change Password',
        this.authService.getToken(), this.authService.getUserId()
      ))
    );
  }

  logout(): void {
    this.auditLogService.saveAuditLog(
      'POST', '/logout', 'User logged out of the system', 'Logout',
      this.authService.getToken(), this.authService.getUserId()
    ).subscribe({
      next: () => {
        this.authService.clearSession();
        this.customToast.success("User Logged Out Successfully");
        this.router.navigate(['/features/login']);
      },
      error: (err) => {
        this.authService.clearSession();
        this.customToast.success("User Logged Out Successfully");
        console.log('error to save audit', err)
        this.router.navigate(['/features/login']);
      }
    });
  }

  getAuditLogs(
    token: string, 
    request: vo.GetAuditLogsRequestI,
    page: number = 1, 
    size: number = 10
  ): Observable<vo.GetAuditLogsResponseI> {
    const headers = new HttpHeaders({
      Authorization: "Bearer " + token,
    });

    return this.http.post<vo.GetAuditLogsResponseI>(
      `${this.apiUrl}/audit/getAll?page=${page}&size=${size}`,
      request,
      { headers: headers }
    );
  }

  // ADMIN DASHBOARD DATA
  getAdminDashboardData(token: string): Observable<vo.AdminDashboardDataResponse> {
    const headers = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.http.get<vo.AdminDashboardDataResponse>(
      `${this.apiUrl}/v2/admin/dashboard/getData`,
      { headers: headers }
    );
  }

  exportAdminDashboardData(
    token: string,
  ): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: "Bearer " + token,
    });

    return this.http.get(
      `${this.apiUrl}/v2/admin/dashboard/exportData`,
      { headers: headers, responseType: "blob" as "json" }
    ).pipe(
      tap(() => this.auditLogService.log(
        'GET', '/v2/admin/dashboard/exportData', 'Exported dashboard data', 'Dashboard - Export Data',
        this.authService.getToken(), this.authService.getUserId()
      ))
    );
  }

  // MERCHANT DASHBOARD DATA
  getDashboardData(token: string): Observable<BaseResponse<vo.DashboardResultI>> {
    const headers = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.http.get<BaseResponse<vo.DashboardResultI>>(
      `${this.apiUrl}/v2/dashboard/getData`,
      { headers: headers }
    );
  }


  getRandomRefNo(
    token: string,
    merchantId: string
  ): Observable<BaseResponse<vo.RandomUidI>> {
    const headers = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.http.get<BaseResponse<vo.RandomUidI>>(
      `${this.apiUrl}/v2/no-code/payment/random-ref-no?merchantId=${merchantId}`,
      { headers: headers }
    );
  }

  getBusinessPartners(): Observable<vo.GetBusinessPartnersResponse> {
    return this.http.get<vo.GetBusinessPartnersResponse>(
      `${this.apiUrl}/v2/merchant-info/getPartners`,
    )
  }

  getUserDetails(
    token: string
  ): Observable<BaseResponse<vo.ProfileDetailsResponse>> {
    const headers = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.http.get<BaseResponse<vo.ProfileDetailsResponse>>(
      `${this.apiUrl}/v2/users/get-profile-details`,
      { headers: headers }
    );
  }

  getMerchantInfo(
    token: string,
    merchantId: string
  ): Observable<BaseResponse<vo.MerchantInfo>> {
    const headers = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.http.get<BaseResponse<vo.MerchantInfo>>(
      `${this.apiUrl}/v2/merchant-info/${merchantId}/getOne`,
      { headers: headers }
    );
  }

  saveMerchantInfo(
    token: string,
    merchantId: string,
    data: vo.MerchantInfoRequest
  ): Observable<BaseResponse<null>> {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + token,
    });

    const formData = new FormData();
    formData.append('merchantId', merchantId);

    const appendField = (
      key: string,
      value: string | number | File | null | undefined
    ) => {

      // undefined = do not send field
      if (value === undefined) {
        return;
      }

      // FILE
      if (value instanceof File) {
        formData.append(key, value);
        return;
      }

      // NULL
      // IMPORTANT:
      // For MultipartFile in Spring Boot,
      // append EMPTY BLOB instead of empty string.
      if (value === null) {

        if (key === 'merchantLogo') {

          // sends empty multipart file
          formData.append(
            key,
            new Blob([], { type: 'application/octet-stream' }),
            ''
          );

        } else {

          // normal nullable string fields
          formData.append(key, '');

        }

        return;
      }

      // NORMAL VALUE
      formData.append(key, value.toString());
    };

    appendField('legalName',          data.legalName);
    appendField('displayName',        data.displayName);
    appendField('description',        data.description);
    appendField('businessType',       data.businessType);
    appendField('mccCode',            data.mccCode);
    appendField('mccDescription',     data.mccDescription);
    appendField('registrationNumber', data.registrationNumber);
    appendField('registrationType',   data.registrationType);
    appendField('websiteUrl',         data.websiteUrl);
    appendField('countryCode',        data.countryCode);
    appendField('riskLevel',          data.riskLevel);
    appendField('merchantLogo',       data.merchantLogo);

    return this.http.put<BaseResponse<null>>(
      `${this.apiUrl}/v2/merchant-info/update`,
      formData,
      { headers }
    ).pipe(
      tap(() => this.auditLogService.log(
        'PUT', '/v2/merchant-info/update', 'MID - Update Merchant Info: ' + merchantId, 'MID - Update Merchant Info',
        this.authService.getToken(), this.authService.getUserId()
      ))
    );
  }

  updateMerchantStatus(
    token: string,
    request: vo.MerchantChangeStatusRequest
  ): Observable<BaseResponse<null>> {
    const headers = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.http.put<BaseResponse<null>>(
      `${this.apiUrl}/v2/admin/merchant/update-status`,
      request,
      { headers }
    ).pipe(
      tap(() => this.auditLogService.log(
        'PUT', '/v2/admin/merchant/update-status', 'MID - Update Merchant Status: ' + request.merchantId, 'MID - Update Merchant Status',
        this.authService.getToken(), this.authService.getUserId()
      ))
    );
  }

  uploadUserImage(
    token: string,
    image: File
  ): Observable<BaseResponse<{}>> {
    const headers = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    const formData = new FormData();
    formData.append('image', image);
    return this.http.post<BaseResponse<{}>>(
      `${this.apiUrl}/v2/users/upload-profile-image`,
      formData,
      { headers: headers }
    );
  }

  mayOtpPayment(
    dataBody: any,
    merchantId: string,
    token: string
  ): Observable<BaseResponse<vo.OtpPaymentResponseI>> {
    const headers = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.http.post<BaseResponse<vo.OtpPaymentResponseI>>(
      `${this.apiUrl}/v2/no-code/payment/otp?merchantId=${merchantId}`,
      dataBody,
      { headers: headers }
    ).pipe(
      tap(() => this.auditLogService.log(
        'POST', '/v2/no-code/payment/otp', 'Created new OTP transaction', 'Transactions - New Transaction',
        this.authService.getToken(), this.authService.getUserId()
      ))
    );
  }

  mayQrPayment(
    dataBody: any,
    merchantId: string,
    token: string
  ): Observable<BaseResponse<vo.QrPaymentResponseI>> {
    const headers = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.http.post<BaseResponse<vo.QrPaymentResponseI>>(
      `${this.apiUrl}/v2/no-code/payment/qr?merchantId=${merchantId}`,
      dataBody,
      { headers: headers }
    ).pipe(
      tap(() => this.auditLogService.log(
        'POST', '/v2/no-code/payment/qr', 'Created new QR transaction', 'Transactions - New Transaction',
        this.authService.getToken(), this.authService.getUserId()
      ))
    );
  }

  mayCcPayment(
    dataBody: any,
    merchantId: string,
    token: string
  ): Observable<BaseResponse<vo.CcPaymentResponseI>> {
    const headers = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.http.post<BaseResponse<vo.CcPaymentResponseI>>(
      `${this.apiUrl}/v2/no-code/payment/credit-card?merchantId=${merchantId}`,
      dataBody,
      { headers: headers }
    ).pipe(
      tap(() => this.auditLogService.log(
        'POST', '/v2/no-code/payment/credit-card', 'Created new card payment transaction', 'Transactions - New Transaction',
        this.authService.getToken(), this.authService.getUserId()
      ))
    );
  }

  sendForgotPassword(
    dataBody: any
  ): Observable<BaseResponse<vo.SendForgotPassword>> {
    return this.http.post<BaseResponse<vo.SendForgotPassword>>(
      `${this.apiUrl}/v2/password/forgot-password`,
      dataBody
    );
  }

  verifyForgotPassword(dataBody: any): Observable<BaseResponse<{}>> {
    return this.http.patch<BaseResponse<{}>>(
      `${this.apiUrl}/v2/password/verify-and-update`,
      dataBody
    );
  }

  triggerWebhook(
    merchantId: string,
    securipayTnxId: string,
    token: string
  ): Observable<BaseResponse<{}>> {
    const headers = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.http.get<BaseResponse<{}>>(
      `${this.apiUrl}/v2/webhook/trigger-webhook?merchantId=${merchantId}&securipayTnxId=${securipayTnxId}`,
      { headers: headers }
    );
  }

  saveWebHook(dataBody: any, token: string): Observable<BaseResponse<{}>> {
    const headers = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.http.post<BaseResponse<{}>>(
      `${this.apiUrl}/v2/webhook/save-call-back`,
      dataBody,
      { headers: headers }
    );
  }

  exportTransactions(
    token: string,
    isExport: boolean,
    filterOptions: any = {}
  ): Observable<any> {
    const filterParams = new URLSearchParams();

    if (filterOptions.merchantName) filterParams.append("merchantName", filterOptions.merchantName);
    if (filterOptions.merchantId) filterParams.append("merchantId", filterOptions.merchantId);
    if (filterOptions.transactionNo) filterParams.append("refNo", filterOptions.transactionNo);
    if (filterOptions.status) filterParams.append("status", filterOptions.status);
    if (filterOptions.startDate) filterParams.append("startDate", filterOptions.startDate + ' 00:00:00');
    if (filterOptions.endDate) filterParams.append("endDate", filterOptions.endDate + ' 00:00:00');

    const filterQuery = filterParams.toString() ? `&${filterParams.toString()}` : "";

    const headers = new HttpHeaders({
      Authorization: "Bearer " + token,
    });

    return this.http.get(
      `${this.apiUrl}/v2/transaction-detail/record?page=1&isExport=${isExport}${filterQuery}`,
      { headers: headers, responseType: isExport ? ("blob" as "json") : "json" }
    ).pipe(
      tap(() => this.auditLogService.log(
        'GET', '/v2/transaction-detail/record', 'Exported transaction list', 'Transactions - Export Data',
        this.authService.getToken(), this.authService.getUserId()
      ))
    );
  }

  exportDashboardData(
    token: string,
  ): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: "Bearer " + token,
    });

    return this.http.get(
      `${this.apiUrl}/v2/dashboard/exportData`,
      { headers: headers, responseType: "blob" as "json" }
    ).pipe(
      tap(() => this.auditLogService.log(
        'GET', '/v2/dashboard/exportData', 'Exported dashboard data', 'Dashboard - Export Data',
        this.authService.getToken(), this.authService.getUserId()
      ))
    );
  }

  exportMidList(
    token: string,
    isExport: boolean,
    filterOptions: any = {}
  ): Observable<any> {
    const filterParams = new URLSearchParams();

    if (filterOptions.merchantName) filterParams.append("merchantName", filterOptions.merchantName);
    if (filterOptions.merchantId) filterParams.append("merchantId", filterOptions.merchantId);
    if (filterOptions.startDate) filterParams.append("startDate", filterOptions.startDate + ' 00:00:00');
    if (filterOptions.endDate) filterParams.append("endDate", filterOptions.endDate + ' 00:00:00');

    const filterQuery = filterParams.toString() ? `&${filterParams.toString()}` : "";

    const headers = new HttpHeaders({
      Authorization: "Bearer " + token,
    });

    return this.http.get(
      `${this.apiUrl}/v2/merchant-info/record?&page=1&isExport=${isExport}${filterQuery}`,
      { headers: headers, responseType: isExport ? ("blob" as "json") : "json" }
    ).pipe(
      tap(() => this.auditLogService.log(
        'GET', '/v2/merchant-info/record', 'Exported MID list', 'MID - Export Data',
        this.authService.getToken(), this.authService.getUserId()
      ))
    );
  }

  exportAuditLogs(request: vo.GetAuditLogsRequestI): Observable<any> {
    const token = this.authService.getToken();
    const headers = new HttpHeaders({
      Authorization: "Bearer " + token,
    });

    return this.http.post(
      `${this.apiUrl}/audit/exportAll`,
      request,
      { headers: headers, responseType: ("blob" as "json")}
    );
  }

  contactUs(request: vo.ContactUsRequest): Observable<BaseResponse<null>> {
    return this.http.post<BaseResponse<null>>(
      `${this.apiUrl}/v2/contact-us/send`,
      request,
    );
  }
}